<template>
    <div>
      <el-container>
        <el-header>
          <navLine/>
          <navbar/>
          <navbarMobile/>
        </el-header>

        <el-main>
          <sport/>
        </el-main>

        <el-footer>
          <footerEnd/>
        </el-footer>

      </el-container>
      <Backtop/>
      <Callphone/>
    </div>
</template>

<script>
  import navbar from 'components/navbar';
  import navbarMobile from 'components/navbarMobile';
  import navLine from 'components/navLine';
  import Backtop from 'base/backtop';
  import Callphone from 'base/callphone';
  import sport from './sport';
  import footerEnd from 'components/footer';

  export default {
    name: 'Home',
    components: {
      navbar,
      navbarMobile,
      navLine,
      Backtop,
      Callphone,
      sport,
      footerEnd
    }
  };

</script>

<style lang="scss" scoped>
  .el-header {
    padding: 0;
    height: auto !important;
  }
  .el-main {
    padding: 0;
    overflow: hidden;
    // background-color: #fff;
    background: url("../../assets/img/bg.jpg") center center;
    background-repeat: repeat-y;
    // repeat-y
    background-size: cover;
  }
  .el-footer {
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home/index.vue